import { gql } from '@apollo/client';
export const [ANONYMOUS_FOLDER, FOLDER] = [true, false].map((anonymous) => gql `
    query getFolderById(
      $id: String!
      ${anonymous ? `$token: String!` : ''}
    ) {
      folder(id: $id, ${anonymous ? ` token: $token` : ''}) {
        id
        pk
        name
        description
        ${!anonymous
    ? `owner {
          pk
        }
        # TODO first 255 could avoided by exposing a property with the total
        # amount of members
        members(first: 255) {
          edges {
            node {
              pk
              avatarUrl
              email
              username
            }
          }
        }`
    : ''}
        modifiedAt
        passwordProtected
      }
    }
  `);
